import { Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { sellerLabel, formatRelativeTime } from '~/utils';
import { PendingOrdersColumn } from './shared/PendingOrdersColumn';

export function PendingConfirmationColumn() {
  const { t } = useTranslation('dashboard');
  return (
    <PendingOrdersColumn
      perspective="BUYING"
      title={t('dashboard.pending_confirmation.title')}
      subtitle={t('dashboard.pending_confirmation.subtitle')}
      footerLink="/buyer-orders/pending-seller-confirmation"
      footerLabel={t('dashboard.pending_confirmation.footer')}
      emptyText={t('dashboard.pending_confirmation.empty')}
      errorText={t('dashboard.pending_confirmation.error')}
      getOrgLabel={(order) => sellerLabel(order.sellingOrganization)}
      renderRow3Right={(order) => (
        <p className="flex items-center gap-1 text-xs font-medium text-warning-600">
          <Clock size={12} aria-hidden="true" />
          {t('dashboard.pending_confirmation.submitted', {
            time: formatRelativeTime(order.createdAt, t),
          })}
        </p>
      )}
    />
  );
}
